import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { ILead, LeadPaymentMethod } from "../../models/Lead";
import { useState } from "react";
import ClickToCopy from "../shared/ClickToCopy";
import classNames from "../../utils/classNames";

export default function PaymentDetails({ lead }: { lead: ILead }) {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!lead.sortCode || !lead.accountNumber || !lead.accountName) {
    return (
      <div className="bg-gray-100 p-4 rounded-lg border border-gray-300">
        <p className="text-gray-600 font-medium">Payment Details Incomplete</p>
      </div>
    );
  }

  // Format sort code as 00-00-00
  const formatSortCode = (sortCode: string) => {
    if (!sortCode) return "";
    const cleaned = sortCode.replace(/\D/g, "");
    if (cleaned.length === 6) {
      return `${cleaned.slice(0, 2)}-${cleaned.slice(2, 4)}-${cleaned.slice(4, 6)}`;
    }
    return sortCode;
  };

  return (
    <div onClick={(e) => e.stopPropagation()} className="bg-gray-100 rounded-lg border border-gray-300 overflow-hidden">
      <button
        onClick={(e) => {
          e.stopPropagation();
          setIsExpanded(!isExpanded);
        }}
        className={`w-full text-left hover:bg-gray-200 transition-colors duration-200 flex items-center justify-between p-2`}
      >
        <span className={classNames(isExpanded ? "text-xs" : "text-sm", "font-medium text-gray-800")}>Payment Details</span>

        <ChevronDownIcon className={`w-5 h-5 text-gray-600 transition-transform duration-200 ${isExpanded ? "rotate-180" : ""}`} />
      </button>

      {isExpanded && (
        <div className="space-y-3">
          <div className="flex flex-col gap-y-2 bg-white p-3 rounded border border-gray-200">

            {lead.paymentMethod === LeadPaymentMethod["Bank Transfer"] && (
              <>
                <div>
                  <span className="text-gray-500 font-medium">Sort Code:</span>
                  <p className="text-gray-800 font-mono"><ClickToCopy text={formatSortCode(lead.sortCode)} value={lead.sortCode} /></p>
                </div>
                <div>
                  <span className="text-gray-500 font-medium">Account Number:</span>
                  <p className="text-gray-800 font-mono"><ClickToCopy text={lead.accountNumber} /></p>
                </div>
                <div>
                  <span className="text-gray-500 font-medium">Account Name:</span>
                  <p className="text-gray-800"><ClickToCopy text={lead.accountName} /></p>
                </div>
              </>
            )}
            <div>
              <span className="text-gray-500 font-medium">Payment Reference:</span>
              <p className="text-gray-800 font-mono"><ClickToCopy text={lead.paymentReference} /></p>
            </div>

          </div>
        </div>
      )}
    </div>
  );
}